import fetch from "@/uilts/request";


export default {
    /**
     * 创建授权书
     */
     getLsbg(data) {
        return  fetch.post("Lsbg/getLsbg", data)
    },
}